import React from 'react';
import { View, Text, useColorScheme } from 'react-native';

import { FontAwesome } from '@expo/vector-icons';
import Colors from '../../constants/Colors';

interface TabBarButtonProps {
  iconName: string;
  focused: boolean;
  badgeCount?: number;
}

const TabBarButton = (props: TabBarButtonProps) => {
  const { iconName, focused, badgeCount } = props;
  const colorScheme = useColorScheme();

  return (
    <View style={{ position: 'relative' }}>
      <TabBarIcon
        name={iconName}
        color={
          focused
            ? Colors[colorScheme as 'light' | 'dark'].tabIconSelected
            : Colors[colorScheme as 'light' | 'dark'].tabIconDefault
        }
      />
      {(badgeCount ?? 0) > 0 && (
        <View
          style={{
            position: 'absolute',
            top: -2,
            right: -10,
            backgroundColor: 'red',
            borderRadius: 12,
            minWidth: 24,
            height: 16,
            justifyContent: 'center',
            alignItems: 'center',
            paddingHorizontal: 6,
          }}
        >
          <Text style={{ color: 'white', fontSize: 10, fontWeight: 'bold' }}>
            {(badgeCount ?? 0) > 99 ? '99' : badgeCount ?? 0}
          </Text>
        </View>
      )}
    </View>
  );
};

const TabBarIcon = (props: { name: string; color: string }) => {
  return <FontAwesome size={30} style={{ marginBottom: -3 }} {...props} />;
};

export default TabBarButton;
